export default __webpack_public_path__ + "static/media/MCSW-logo-35anniversary-dark-background.a1877e3f.svg";